import { authGetters } from "./auth";
import { settingGetters } from "./appSetting";
import { companyGetters } from "./compnay";

export default {
  ...authGetters,
  ...settingGetters,
  ...companyGetters
};
